module.exports = __webpack_public_path__ + "img/m.d998961d.jpg";